<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="internalDate"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{on, attrs}">
      <v-text-field
        v-bind="{ ...attrs, class: $vnode.data.staticClass }"
        v-on="on"
        :value="display_date"
        prepend-icon="mdi-calendar"
        :label="label || $t('label.date')"
        readonly
        :disabled="disabled"
      >
      </v-text-field>
    </template>
    <v-date-picker v-model="internalDate" no-title scrollable>
      <v-spacer />
      <v-btn text color="primary" @click="menu = false">
        {{ $t("button.cancel") }}
      </v-btn>
      <v-btn text color="primary" @click="saveDate()">
        {{ $t("button.save") }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DatePickerMenu",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      type: [String, Date, null],
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      internalDate: this.normalize_to_picker_string(this.value),
      menu: false
    };
  },
  watch: {
    value(newVal) {
      this.internalDate = this.normalize_to_picker_string(newVal);
    }
  },
  computed: {
    display_date() {
      if (!this.internalDate) return "";
      return this.$options.filters.date(this.internalDate);
    }
  },
  methods: {
    saveDate() {
      this.$refs.menu.save(this.internalDate);
      this.$emit("input", this.internalDate);
    },
    normalize_to_picker_string(val) {
      return this.$options.filters.date_picker_string(val);
    }
  }
};
</script>
